import React from "react";
import { useSelector } from "react-redux";

interface Comment {
  id: number;
  title: string;
  comment: string;
  createdAt: string;
  type: "success" | "warning" | "danger";
  userRole?: { Role_Name: string };
  status: string;
}

interface CommentModalProps {
  comments: Comment[];
}

const ApplicationTimelineModal: React.FC<CommentModalProps> = ({
  comments,
}) => {
  const statusmapping={
    open: "Open",
    closed: "Closed",
    pending: "Pending",
    reject: "Raise Query",
    approved: "Approved",
    resubmission: "Resubmission",
    permanentReject: "Permanent Rejection",
    approvedUnsigned: "Approved Unsigned",
  }
    const fieldsOptions =  [
    { value: "applicantName", label: "Applicant Name" },
    { value: "perAddress", label: "Permanent Address" },
    {value:"currAddress", label:"Current Address"},
    { value: "regOffAddress", label: "Registered Office Address" },
    { value: "regEmailId", label: "Registered Email ID" },
    { value: "mobileNo", label: "Mobile Number" },
    { value: "dob", label: "DOB" },
    { value: "yrOfExpAsBusErr", label: "Year of Experience as Business Engineer" },
    // { value: "itReturnDetail", label: "IT Returns for Last Three years" },
    // { value: "declarationDetail", label: "Applicant Declaration" },
    { value: "entityName", label: "Entity Name" },
    // { value: "entityType", label: "Entity Type" },
    { value: "entityRegistrationNo", label: "Entity Registration Number" },
    { value: "entityGstNo", label: "Entity GST Number" },
    { value: "entityPanNo", label: "Entity PAN Number" },
    { value: "entityFpoNo", label: "Entity FPO Number" },
    { value: "guarantorDetail_1", label: "Gurantor 1 Details" },
    { value: "guarantorDetail_2", label: "Gurantor 2 Details" },
    { value: "bankDetails", label: "Bank Details" },
    { value: "highSchool", label: "High School" },
    { value: "diploma", label: "Diploma" },
    { value: "bachelorDegree", label: "Bachelor's Degree" },
    { value: "mastersDegree", label: "Master's Degree" },
    { value: "phd", label: "PHD" },
    { value:"itReturns_1",label:"IT Returns 1"},
    { value:"itReturns_2",label:"IT Returns 2"},
    { value:"itReturns_3",label:"IT Returns 3"},
    { value: "experienceDoc_1", label: "Experience Detail One" },
    { value: "experienceDoc_2", label: "Experience Detail Two" },
    { value: "experienceDoc_3", label: "Experience Detail Three" },
    { value: "workPerformanceDoc_1", label: "Work Performed Detail One" },
    { value: "workPerformanceDoc_2", label: "Work Performed Detail Two" },
    { value: "workPerformanceDoc_3", label: "Work Performed Detail Three" },
    { value: "constructionDocs_1", label: "Construction Done Details One" },
    { value: "constructionDocs_2", label: "Construction Done Details Two" },
    { value: "constructionDocs_3", label: "Construction Done Details Three" },
    { value: "structureErrDoc", label: "Structural Engineering" },
  { value: "tarderPhoto", label: "Trader Photo" },
    { value: "solvencyCertificate", label: "Solvency Certificate" },
    { value: "bankGuarntee", label: "Bank Guarntee" },
    { value: "bankBalanceCertificate", label: "Bank Balance Certificate" },
    { value: "panCardNo", label: "Pan Card Number" },
    // { value: "itReturns", label: "IT Returns(for last three years)" },
    { value:"itReturns_1",label:"IT Returns 1"},
    { value:"itReturns_2",label:"IT Returns 2"},
    { value:"itReturns_3",label:"IT Returns 3"},
    { value: "electionCard", label: "Election Card" },
    { value: "chalanPayementLiceneseFee", label: "Challan (in support of payment of license fees)" },
    { value: "proofOfBusinessPalace", label: "Proof of Place of Business" },
    { value: "partnerShipDeed", label: "Partnership Deed" },
    { value: "companyArticleAssociation", label: "Article of Association" },
    { value: "companyAttorneyAuthorization", label: "Power of Attorney of Authorized Person" },
    { value: "coOpSocietyRegCertificate", label: "Co-operative Society Registration Certificate" },
    { value: "coOpSocietyByLaws", label: "Co-operative Society Bye-Laws" },
    { value: "coOpSocietyResObtLic", label: "Co-operative Society Resolution for Obtaining License" },
    { value: "coOpSocietyAuditReport", label: "Co-operative Society of Last Audit Report" },
    { value: "coOpSocietyIncomeExpenditure", label: "Co-operative Society Income-Expenditure Statement" },
    { value: "coOpSocietyBalanceSheetThreeYear", label: "Co-operative Society Balance Sheet for Last Three Years" },
    { value: "affidavit", label: "Proof of Probable Place Of Business and Market Committee" },
    { value: "enclousreDeclaration", label: "Enclosure Declaration" },
    { value: "declaration", label: "Declaration" },
    { value: "traderSignature", label: "Trader Signature" },
    // { value: "guarantorPanCard_1", label: "Guarantor 1 Pan Card " },
    // { value: "guarantorPanCard_2", label: "Guarantor 2 Pan Card " },


    // { value: "guarantorPhoto_1", label: "Guarantor 1 Photo" },
    // { value: "guarantorPhoto_2", label: "Guarantor 2 Photo" },

    // { value: "guarantorSignature_1", label: "Guarantor 1 Signature" },
    // { value: "guarantorSignature_2", label: "Guarantor 2 Signature" },

    { value: "guarantorDeclaration", label: "Guarantor Declaration" },
    { value: "license", label: "License" }

  ];
  const language = useSelector((state: any) => state.auth.language);
  //.log('comments', comments)
  const sortedComments =
    comments?.length > 0
      ? [...comments].sort(
          (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        )
      : [];

  return (
    <div
      className="modal fade"
      id="comment_modal"
      tabIndex={-1}
      aria-labelledby="commentModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="commentModalLabel">
              {language.comment}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {sortedComments.length > 0 ? (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <ul className="timeline">
                        {sortedComments.map((comment, index) => {
                          const formattedDate = new Date(
                            comment.createdAt
                          ).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          });

                          return (
                            <li
                              key={comment.id}
                              className={
                                index % 2 !== 0 ? "timeline-inverted" : ""
                              }
                            >
                              <div className="timeline-badge success">
                                <i className="fas fa-user" />
                              </div>
                              <div className="timeline-panel border border-info  rounded-4  bg-light shadow-sm ">
                                <div className="d-flex justify-content-between align-items-start">
                                   <div className="me-4 w-100">
      <div className="d-flex align-items-center mb-2 flex-wrap">
        <h6 className="mb-0 me-2 fw-semibold text-primary">
         Role:
        </h6>
        <span className="badge bg-secondary">
          {comment?.userRole?.Role_Name || "Not Found"}
        </span>
      </div>
     
  { comment?.comment && comment?.comment.trim() !== "" && <p className="mb-1 small text-dark text-break">
       <span><strong>{language.comment}:</strong>{" "}</span> 
        {/* Map field keys to labels if comment is in key: value, ... format */}
        {(() => {
          const commentStr = comment?.comment || "";
          // Check if comment looks like key: value, ...
          if (/([a-zA-Z_]+\s*:\s*[^,]+,?\s*)+/.test(commentStr)) {
            // Split by comma, then by colon
            return commentStr.split(",").map((pair, idx) => {
              const [key, value] = pair.split(":").map(s => s && s.trim());
              if (!key || value === undefined) return pair; // fallback
              const field = fieldsOptions.find(f => f.value === key);
              const label = field ? field.label : key;
              return (
                <span key={key + idx}>
                  {label}: {value}{idx < commentStr.split(",").length - 1 ? ", " : ""}
                </span>
              );
            });
          } else {
            return commentStr;
          }
        })()}
      </p>}
      <p className="mb-0 small text-dark text-break">
        <strong>{language.status}:</strong>{" "}
        {statusmapping[comment?.status]? statusmapping[comment.status] : comment?.status }
      </p>
    </div>

                                  <span className="text-muted small">
                                    <b>{formattedDate}</b>
                                  </span>
                                </div>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-muted">No comments available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTimelineModal;
